import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoginService } from './login.service';
import { SocialAuthService, GoogleLoginProvider } from 'angularx-social-login';
import { Router } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { S3Service } from '../services/s3.service';
import { SharedService } from "../services/shared.service";
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  userName: FormGroup;
  password: FormGroup;
  errorMessage: String;
  hide: Boolean;
  logo;
  loggedIn: Boolean = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _loginService: LoginService,
    private _authService: SocialAuthService,
    private _router: Router,
    private _cookieService: CookieService,
    private _s3Service: S3Service,
    private _sharedService : SharedService,
    private _dialogService: MatDialog
  ) { }

  ngOnInit() {
    if (localStorage.getItem('email')) {
      let url = localStorage.getItem("organizationCode") + "/dashboard";
      this._router.navigateByUrl(url);
    }
    // declaring the login form
    this.loginForm = this._formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login() {
    this.errorMessage = "";
    if (this.loginForm.value.username === "" || this.loginForm.value.password === "") {
      this.errorMessage = "Please enter credentials to login.";
      return;
    }
    // Data for API call
    let userData = {
      email: this.loginForm.value.username,
      password: this.loginForm.value.password,
      loginType: "email"
    };

    // API call
    this._loginService.login(userData).subscribe(async (response: any) => {
      if (response["success"]) {
        this.loginForm.setValue({
          username: '',
          password: ''
        });
        localStorage.setItem('email', response['user']['email']);
        localStorage.setItem('organization', response['user']['organization']);
        localStorage.setItem('role', response['user']['role']);
        localStorage.setItem('username', response['user']['username']);
        localStorage.setItem('firstName', response['user']['firstName']);
        localStorage.setItem('lastName', response['user']['lastName']);
        localStorage.setItem('organizationLogo', response['user']['organizationLogo']);
        if(response['user']['address'] && response['user']['address']['state']) {
          localStorage.setItem('organizationAddress', response['user']['address']['state']);
        }
        localStorage.setItem('organizationName', response['user']['organizationName']);
        localStorage.setItem('organizationCode', response['user']['organizationCode']);
        localStorage.setItem('userId', response['user']['userId']);
        localStorage.setItem('tooltip_enabled', response['user']['tooltip_enabled'])
        localStorage.setItem('organizations', JSON.stringify(response['user']['organizations']))
        if (response['user']['theme'] && response['user']['theme']['bg_color'])localStorage.setItem('bgColor', response['user']['theme']['bg_color']);
        if (response['user']['theme'] && response['user']['theme']['bg_text_color'])localStorage.setItem('bgTextColor', response['user']['theme']['bg_text_color']);
        this._cookieService.set('isLoggedIn', "true");
        this.loggedIn = true;
        if(response['user'] && response['user']['tooltip_enabled'] == undefined) {
          localStorage.setItem('tooltip_enabled', 'true')
        }

        if(response['user'] && response['user']['timezone']) {
          localStorage.setItem('timezone', response['user']['timezone'])
        }

        let url =  "";
        localStorage.setItem('enable_subscription', response['enable_subscription'] || false);
        let userPrivileges: any = await this.getUserPrevilaiges()
        if(userPrivileges.includes("super_user")) {
          this._cookieService.set('super_admin', "true");
          if (!userPrivileges.includes("dashboard")) {
            return this._router.navigateByUrl('/organizations')
          }
        }
        this._router.navigateByUrl('/teams-selection')
      } else {
        this.errorMessage = response.message;
      }
    }, (error) => {
      if(error.error && error.error.message) {
        return;
      }
      this.errorMessage = "Server side error occurred";
    });
  }

  getUserPrevilaiges() {
    return new Promise((resolve, reject) => {
      this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe(response => {
        resolve(response['data'][0]['privileges'])
      }, error => {
        resolve(error)
      })
    })
  }

  googleLogin() {
    this.loginForm.reset();
    let socialServiceProvider = GoogleLoginProvider.PROVIDER_ID;
    this._authService.signIn(socialServiceProvider).then((response) => {
      let userData = {
        id: response.id,
        idToken: response.idToken,
        provider: response.provider,
        authToken: response.authToken,
        email: response.email,
        loginType: "google"
      };

      // API call
      this._loginService.login(userData).subscribe((response: any) => {
        if (response["success"]) {
          this.loginForm.setValue({
            username: '',
            password: ''
          });
          localStorage.setItem('email', response['user']['email']);
          localStorage.setItem('organization', response['user']['organization']);
          localStorage.setItem('role', response['user']['role']);
          localStorage.setItem('username', response['user']['username']);
          localStorage.setItem('firstName', response['user']['firstName']);
          localStorage.setItem('lastName', response['user']['lastName']);
          // localStorage.setItem('userLogo', response['user']['userLogo']);
          localStorage.setItem('address', response['user']['address']['state']);
          localStorage.setItem('organizationName', response['user']['organizationName']);
          localStorage.setItem('organizationCode', response['user']['organizationCode']);
          localStorage.setItem('userId', response['user']['userId']);
          if (response['user']['theme'] && response['user']['theme']['bg_color'])localStorage.setItem('bgColor', response['user']['theme']['bg_color']);
          this._cookieService.set('isLoggedIn', "true");
          this.loggedIn = true;
          const url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/dashboard']));
          window.open(url, "_self");
        } else {
          this.errorMessage = response.message;
        }
      }, (error) => {
        this.errorMessage = error.error.message;
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  fetchLogoFromS3(key) {
    if (key.length > 0) {
      this._s3Service.getObjectFromKey(key).subscribe((response) => {
        var binary = '';
        var bytes = new Uint16Array(response['data']);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        let bb = window.btoa(binary);
        let logo = "data:image/jpeg;base64," + bb;
        this.logo = logo;
      }, (error) => {
        console.log(error);
      });
    }
  }

  onResetPassword() {
    this._dialogService.open(ResetPasswordComponent);
  }
}
